import { render, staticRenderFns } from "./ProductPriceListing.vue?vue&type=template&id=4253a555"
import script from "./ProductPriceListing.vue?vue&type=script&lang=js"
export * from "./ProductPriceListing.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports